"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDepthFromContentTree = exports.getTestContentTree = exports.isContentTreeImmediatelyAboveBase = exports.indexOfContentPathForFlattenedContentTree = exports.flattenContentTree = exports.walkContentTree = exports.getSubtreeFromID = exports.getSubtreeFromContentPath = exports.getChildIndexOfContentTreeByName = exports.getIndexForContentPathAmongSiblings = void 0;
const ContentPath_1 = require("../ContentPath");
function getIndexForContentPathAmongSiblings(contentPath, contentTree) {
    const node = getSubtreeFromContentPath(contentTree, contentPath.slice(0, contentPath.length - 1));
    return getChildIndexOfContentTreeByName(node, contentPath[contentPath.length - 1]);
}
exports.getIndexForContentPathAmongSiblings = getIndexForContentPathAmongSiblings;
function getChildIndexOfContentTreeByName(contentTree, nodeID) {
    for (const [index, child] of contentTree.children.entries()) {
        if (child.id === nodeID) {
            return index;
        }
    }
    throw new Error(`Unable to find content: ${nodeID} in content tree: ${JSON.stringify(contentTree, null, 2)}`);
}
exports.getChildIndexOfContentTreeByName = getChildIndexOfContentTreeByName;
// Looks up a subtree in the ContentTree by following the ContentPath
function getSubtreeFromContentPath(contentTree, contentPath) {
    let outputTree = contentTree;
    for (const node of contentPath) {
        outputTree = getSubtreeFromID(outputTree, node);
    }
    return outputTree;
}
exports.getSubtreeFromContentPath = getSubtreeFromContentPath;
// Progresses to the next subtree
function getSubtreeFromID(contentTree, nodeID) {
    for (const child of contentTree.children) {
        if (child.id === nodeID) {
            return child;
        }
    }
    throw new Error(`Unable to find node: ${nodeID} in contentTree children: ${contentTree.children
        .map((child) => child.id)
        .join(', ')}`);
}
exports.getSubtreeFromID = getSubtreeFromID;
function walkContentTree(contentTree, contentPath, leafNodeCallback, subtreeCallback) {
    if (contentTree.children.length === 0) {
        leafNodeCallback(contentTree, contentPath);
    }
    else {
        subtreeCallback(contentTree, contentPath);
        for (const subtree of contentTree.children) {
            const currentPath = [...contentPath, subtree.id];
            walkContentTree(subtree, currentPath, leafNodeCallback, subtreeCallback);
        }
    }
}
exports.walkContentTree = walkContentTree;
function flattenContentTree(contentTree, storeNodes = false) {
    const leafContentPaths = [];
    const subtreeContentPaths = [];
    walkContentTree(contentTree, [], (node, path) => {
        leafContentPaths.push(path);
    }, (node, path) => {
        subtreeContentPaths.push(path);
    });
    if (storeNodes) {
        return subtreeContentPaths.concat(leafContentPaths);
    }
    return leafContentPaths;
}
exports.flattenContentTree = flattenContentTree;
function indexOfContentPathForFlattenedContentTree(flattenedContentTree, contentPath) {
    for (const [index, flattenedContentTreeContentPath,] of flattenedContentTree.entries()) {
        if ((0, ContentPath_1.areContentPathsEqual)(flattenedContentTreeContentPath, contentPath)) {
            return index;
        }
    }
    throw new Error(`Unable to locate content path: ${(0, ContentPath_1.hashContentPath)(contentPath)} in flattened content tree`);
}
exports.indexOfContentPathForFlattenedContentTree = indexOfContentPathForFlattenedContentTree;
function isContentTreeImmediatelyAboveBase(contentTree) {
    return (contentTree.children.length > 0 &&
        contentTree.children[0].children.length === 0);
}
exports.isContentTreeImmediatelyAboveBase = isContentTreeImmediatelyAboveBase;
function getTestContentTree(numTopics = 5, numSubtopics = 10, numChapters = 10, makeImbalanced = false) {
    const contentTree = {
        name: 'Exam XYZ',
        id: 'Exam XYZ',
        children: [],
    };
    // for each topic
    for (let i = 0; i < numTopics; i++) {
        const topicObj = {
            name: `Topic${i}`,
            id: `Topic${i}`,
            children: [],
        };
        // for each subtopic in this topic
        for (let j = 0; j < numSubtopics; j++) {
            const subtopicObj = {
                name: `Subtopic${i * 10 + j}`,
                id: `Subtopic${i * 10 + j}`,
                children: [],
            };
            // for each chapter in this subtopic
            for (let k = 0; k < numChapters; k++) {
                const chapterObj = {
                    name: `Chapter${i * 100 + j * 10 + k}`,
                    id: `Chapter${i * 100 + j * 10 + k}`,
                    children: [],
                };
                subtopicObj.children.push(chapterObj);
            }
            // add to topic object
            topicObj.children.push(subtopicObj);
        }
        // add to contentTree
        contentTree.children.push(topicObj);
    }
    if (makeImbalanced) {
        contentTree.children[0].children[0].children = [];
        if (numTopics > 1) {
            contentTree.children[1].children = [];
        }
    }
    return contentTree;
}
exports.getTestContentTree = getTestContentTree;
const getDepthFromContentTree = (contentTree) => {
    let depth = 1;
    let node = contentTree;
    while (!isContentTreeImmediatelyAboveBase(node)) {
        node = node.children[0];
        depth += 1;
    }
    return depth;
};
exports.getDepthFromContentTree = getDepthFromContentTree;
//# sourceMappingURL=contentTree.js.map